import styled from 'styled-components';

import { TextInfo } from '../../../../components/TextInfo';
import { colors, radius } from '../../../../styles/tokens';

export const Container = styled.div`
  padding: 40px;
  min-height: 100vh;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;

  margin-bottom: 24px;

  @media (max-width: 1199px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PageTitle = styled.h1`
  font-size: 32px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.01em;
  margin-bottom: 4px;
`;

export const PageSubtitle = styled.p`
  font-size: 14px;
  color: ${colors.onSurfaceVariant};
`;

export const AddButton = styled.button`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;

  padding: 14px 28px;

  background-color: ${colors.primary};
  border: none;
  border-radius: ${radius.full};
  cursor: pointer;

  color: ${colors.onPrimary};
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  transition: opacity 0.15s;

  &:hover {
    opacity: 0.9;
  }
`;

export const ContainerInfo = styled.div`
  margin-bottom: 32px;

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
`;

export const Info = styled(TextInfo)`
  align-items: flex-start;

  padding: 16px;
  border-radius: ${radius.md};
  border: 1px solid ${colors.outlineVariant}40;
  background-color: ${colors.surfaceContainerLow};

  span {
    text-align: left;
    line-height: 1.5;
  }
`;

export const MainGrid = styled.div`
  // display: grid;
  // grid-template-columns: 2fr 1fr;
  width: 100%;

  @media (max-width: 1199px) {
    grid-template-columns: 1fr;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;

  h3 {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: ${colors.onSurfaceVariant};
    white-space: nowrap;
  }
`;

export const SectionLine = styled.div`
  flex: 1;
  height: 1px;
  background-color: ${colors.outlineVariant}26;
`;

export const WarningsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const NoDataContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;

  padding: 48px 24px;
  border-radius: ${radius.md};
  background-color: ${colors.surfaceContainerLow};

  span {
    color: ${colors.onSurfaceVariant};
    font-size: 13px;
  }
`;

export const PhoneShell = styled.div`
  background: ${colors.surfaceContainerLowest};
  border: 1px solid ${colors.outlineVariant}40;
  border-radius: ${radius.lg};
  padding: 14px;
`;

export const PhoneApp = styled.div`
  background: #100e11;
  border-radius: ${radius.md};
  padding: 20px 16px;
  min-height: 220px;

  display: flex;
  flex-direction: column;
`;

export const PhoneAppLabel = styled.p`
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  text-align: center;
  color: ${colors.onSurfaceVariant};
  margin-bottom: 16px;
`;

export const PhoneCard = styled.div`
  background: #1a171b;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: ${radius.md};
  padding: 14px 15px;
`;

export const PhoneBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;

  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: ${colors.primary};

  background: ${colors.primary}24;
  border: 1px solid ${colors.primary}4d;
  border-radius: ${radius.sm};
  padding: 3px 8px;
`;

export const PhoneCardTitle = styled.p`
  font-size: 15px;
  font-weight: 700;
  color: #f4f1ee;
  margin: 10px 0 4px;
`;

export const PhoneCardContent = styled.p`
  font-size: 13px;
  color: rgba(244, 241, 238, 0.55);
  line-height: 1.5;
`;

export const PhoneEmpty = styled.p`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  text-align: center;
  font-size: 12px;
  color: ${colors.onSurfaceVariant};
`;
